export default "__VITE_ASSET__DW7BOUTs__"